import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c5b4a4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-map-container" }
const _hoisted_2 = {
  ref: "mapContainer",
  class: "map"
}
const _hoisted_3 = { class: "info-box" }
const _hoisted_4 = {
  key: 0,
  class: "text-with-you"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 수많은 혁신의 순간들,")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 당신과 함께 만들고 싶습니다. ")
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "items" }
const _hoisted_10 = { class: "top" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Tel ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 070-4350-4350 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 대표번호 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 1522-7781 ")
const _hoisted_15 = { class: "bottom" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Address ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 경기도 성남시 분당구 판교역로 230 삼환하이펙스 B동 402호 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" E-Mail ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" support@dinosband.com ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DnbMapDetail = _resolveComponent("DnbMapDetail")!
  const _component_DnbChip = _resolveComponent("DnbChip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal-target" }, [
      (_ctx.isOpenModal)
        ? (_openBlock(), _createBlock(_component_DnbMapDetail, {
            key: 0,
            modelValue: _ctx.isOpenModal,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpenModal) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, null, 512),
      (_ctx.platform === 'mobile')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "map-container-wrapper",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMapClick && _ctx.onMapClick(...args)))
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.platform === 'desktop')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_DnbChip, { class: "tel" }, {
            title: _withCtx(() => [
              _hoisted_11
            ]),
            label: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_DnbChip, { class: "fax" }, {
            title: _withCtx(() => [
              _hoisted_13
            ]),
            label: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_DnbChip, { class: "address" }, {
            title: _withCtx(() => [
              _hoisted_16
            ]),
            label: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_DnbChip, { class: "fax" }, {
            title: _withCtx(() => [
              _hoisted_18
            ]),
            label: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}